import { createContext } from 'react';

const DeliveryIdContext = createContext<string | undefined>(undefined);

export default DeliveryIdContext;
